import type { FormArraySchema } from "formvuelate";
import { SchemaForm } from "formvuelate";
import RowText from "@/components/input-formvuelate/RowText.vue";
import { ValueType } from "@/enums/ValueType";

const schema: FormArraySchema = [
	{
		component: SchemaForm,
		model: undefined as unknown as string,
		schema: [
			{
				component: RowText,
				label: "Toetsinkomen",
				model: "toetsinkomen",
				readOnly: true,
				valueType: ValueType.Currency as const,
			},
		],
	},
	{
		component: SchemaForm,
		model: undefined as unknown as string,
		schema: [
			{
				component: RowText,
				label: "Toetsrente leningdeel 1",
				model: "toetsrenteDeel1",
				readOnly: true,
				valueType: ValueType.Percentage as const,
			},
			{
				component: RowText,
				label: "Toetsrente leningdeel 2",
				model: "toetsrenteDeel2",
				readOnly: true,
				valueType: ValueType.Percentage as const,
			},
		],
	},
	{
		component: SchemaForm,
		model: undefined as unknown as string,
		schema: [
			{
				component: RowText,
				label: "Looptijd leningdeel 1",
				model: "looptijdDeel1",
				readOnly: true,
				valueType: ValueType.Number as const,
			},
			{
				component: RowText,
				label: "Looptijd leningdeel 2",
				model: "looptijdDeel2",
				readOnly: true,
				valueType: ValueType.Number as const,
			},
		],
	},
	{
		component: SchemaForm,
		model: undefined as unknown as string,
		schema: [
			{
				component: RowText,
				label: "Optimale hoogte leningdeel 1",
				model: "optimaleHoogteDeel1",
				readOnly: true,
				valueType: ValueType.Currency as const,
			},
			{
				component: RowText,
				label: "Optimale hoogte leningdeel 2",
				model: "optimaleHoogteDeel2",
				readOnly: true,
				valueType: ValueType.Currency as const,
			},
		],
	},
	{
		component: SchemaForm,
		model: undefined as unknown as string,
		schema: [
			{
				component: RowText,
				label: "Maximale hypotheek",
				model: "maximaleHypotheek",
				readOnly: true,
				valueType: ValueType.Currency as const,
			},
		],
	},
];

export default schema;
